import * as PropTypes from "prop-types";
import {Connect} from 'connect-web-sdk';
import ConnectPage from "../consent-management/ConnectPage";
import {FullStory} from "@fullstory/browser";
import {useEffect, useContext, useState} from "react";
import {apiContext} from "../../ApiContext";
import {getDecodedValue, redirectTo} from "../../common/utils";
import {safeTrack} from "../../common/telemetry/SegmentHelper";
import ErrorViewV2 from "../../common/ErrorViewV2";
import {getOnboardingState, setOnboardingState} from "../../common/OnboardingSessionStorage";
import {OnboardingState} from "../../common/OnboardingState";

export default function OnboardOpenBankingInitiate({connectedUrl, productRedirectUrl, state}) {
  const applicationId = getDecodedValue('applicationId', state);
  const consumptionId = getDecodedValue('consumptionId', state);
  const [hasCancelledAccountSelection, setHasCancelledAccountSelection] = useState(false);
  const [connectError, setConnectError] = useState(null);
  const shouldProceedLoading = getOnboardingState(applicationId);
  const api = useContext(apiContext);
  const loadingPageUrl = `/onboard/openbanking/connecting?state=${state}&productRedirectUrl=${encodeURIComponent(productRedirectUrl)}`;

  const renderError = (e) => {
    FullStory('trackEvent', {
      name: 'OpenBanking Connection error',
      properties: {
        error_code: e.code,
        message: e?.reason
      },
    });
    safeTrack(
      'LandOnBankFeedPortalErrorPage', {
        page: '/onboard/openbanking/initiate',
        businessId: consumptionId,
        source: 'OpenBanking',
        consumer: 'SMEP',
        applicationId: applicationId,
        productFamily: 'SME',
        label: 'bank-feeds-portal',
        url: window.location.href
      }
    )
    return <ErrorViewV2 type="openBankingErrorCallRetryable" redirectUrl={productRedirectUrl} />;
  }

  const trackCancelMastercardEvent = async () => {
    await safeTrack(
      'elementClicked', {
        action: hasCancelledAccountSelection ? 'clicked_cancel_account_selection' : 'clicked_exit_consent_page',
        page: 'mastercard',
        businessId: consumptionId,
        source: 'OpenBanking',
        consumer: 'SMEP',
        applicationId
      }
    );
    await safeTrack(
      'ExitFromMastercard', {
        page: '/onboard/openbanking/initiate',
        businessId: consumptionId,
        source: 'OpenBanking',
        consumer: 'SMEP',
        applicationId: applicationId,
        productFamily: 'SME',
        label: 'bank-feeds-portal',
        url: window.location.href
      }
    )
  };

  const connectEventHandlers = {
    onDone: () => {
        setOnboardingState(applicationId, OnboardingState.CONNECTED)
        redirectTo(loadingPageUrl);
        Connect.destroy();
    },
    onCancel: async () => {
      try {
        const status = hasCancelledAccountSelection ? "CancelAccountSelection" : "ExitConsentPage";
        await api.updateApplicationStatusDescription(applicationId, status);
      } finally {
        await trackCancelMastercardEvent();
        redirectTo(productRedirectUrl);
        Connect.destroy();
      }
    },
    onError: (e) => {
      if (e.code === 10024) {
        setOnboardingState(applicationId, OnboardingState.CONNECTED);
        redirectTo(loadingPageUrl);
      } else {
        setConnectError(e);
      }
      Connect.destroy();
    },
    onRoute: () => {},
    onUser: (e) => {
      if (e.action === "DisplayAlert" && e.errorCode === 2003) {
        setHasCancelledAccountSelection(true);
      }
    },
    onLoad: () => {}
  };

  useEffect(() => {
    if (shouldProceedLoading) {
      redirectTo(loadingPageUrl);
    }
  }, []);

  if (shouldProceedLoading) return null;
  if (connectError) {
    return renderError(connectError)
  }
  return (<ConnectPage connectedUrl={connectedUrl} connectEventHandlers={connectEventHandlers}></ConnectPage>)
}

OnboardOpenBankingInitiate.propTypes = {
  connectedUrl: PropTypes.string,
  productRedirectUrl: PropTypes.string,
  state: PropTypes.string
};
